export const COUPON_PROMOS = '/couponPromos';
export const DEFAULT_PAGE_SIZE = 10;
export const STUDENTS = '/students';
export const SMARTTHINGS_SCENES = '/smartthings/scenes';
export const MP_PREFERENCE_LINKS = '/bills/mp-preference-links';
export const BILLS_HISTORY = '/bills/history';
export const BILLS_STATS = '/bills/stats';
export const BILLS_GRAPHIC = '/bills/graphic';
